import { useReducer, useEffect, useState } from "react";
import { isEmpty, cloneDeep } from "lodash";

import {
  notificationCategories,
  notificationFields,
} from "./utils/notificationSettings";
import Field from "./components/field/Field.js";
import Templates from "./components/templates/Templates";
import Editor from "./components/Editor";

import classes from "./components/templates/Templates.module.css";

const setNotificationData = (state, action) => {
  var result;

  let updatedState = cloneDeep(state);
  // console.log(action.data);
  switch (action.type) {
    case "FULL":
      result = action.data;
      break;
    case "FIELDUPDATE":
      if (action.id === "trigger") {
        state.email.forEach((field, index) => {
          if (field.id === "emailSubject") {
            updatedState.email[index].value = action.data.emailSubject;
          }
          if (field.id === "additonalEmailFields") {
            updatedState.email[index].value = false;
          }
        });
        state.general.forEach((field, index) => {
          if (field.id === "template") {
            updatedState[action.category][index].value =
              action.data.defaultTemplate;
          }
        });
      }

      state[action.category].forEach((field, index) => {
        if (field.id === action.id) {
          updatedState[action.category][index].value = action.data;
        }
      });

      // getEmailSubjectFromTrigger(action.data.value);
      result = updatedState;
      break;
    case "TEMPLATEUPDATE":
      state.general.forEach((field, index) => {
        if (field.id === "template") {
          updatedState.general[index].value = action.data;
        }
      });
      result = updatedState;
      break;
    case "EDITORUPDATE":
      updatedState.editor = []; // removing exsiting editor data
      const { components, css, emailhtml } = action.data;
      updatedState.editor.push({ components }, { css }, { emailhtml });

      result = updatedState;
      break;
    default:
      result = state;
  }

  return result;
};

function App() {
  const [notificationData, notificationDispatcher] = useReducer(
    setNotificationData,
    {}
  );
  const [activeMergeFieldId, setActiveMergeFieldId] = useState(false);

  const query = new URLSearchParams(window.location.search);

  // Load Initial State
  useEffect(() => {
    const initialState = {};

    notificationCategories.forEach((categoryName) => {
      initialState[categoryName] = [];
      notificationFields.forEach((field) => {
        const fieldId = field.id;
        const fieldCategory = field.category;
        if (categoryName === fieldCategory) {
          const fieldProperties = {
            id: fieldId,
            conditional: field.conditional,
          };

          let fieldValue = getSavedFieldValue(categoryName, fieldId);

          if (fieldValue === null) {
            // field not found in saved settings
            // getting field value from querystring
            const paramValue = query.getAll(field.param);
            //paramValue is an array
            if (paramValue.length !== 0) {
              fieldValue = paramValue[0];
            } else {
              fieldValue = field.default;
            }
          }

          fieldProperties.value = fieldValue;

          initialState[categoryName].push(fieldProperties);
        }
      });
    });

    notificationDispatcher({
      type: "FULL",
      data: initialState,
    });
  }, []);

  /**
   *
   * @param {string} categoryName name of category of field
   * @param {string} fieldId id of field
   * @returns fieldvalue if present in saved settings
   */
  const getSavedFieldValue = (categoryName, fieldId) => {
    const savedSettings = JSON.parse(window.wpmNotifications);
    let fieldValue = null;
    if (!isEmpty(savedSettings[categoryName])) {
      // category present in saved settings
      savedSettings[categoryName].forEach((savedField) => {
        if (savedField.id === fieldId) {
          fieldValue = savedField.value;
        }
      });
    }

    return fieldValue;
  };

  const updateEditorData = (data) => {
    notificationDispatcher({
      type: "EDITORUPDATE",
      data: data,
    });
  };

  //rendering all notification fields
  const renderAllFields = () => {
    //fields are sorted according to given order
    const sortedNotificationFields = notificationFields.sort(
      (field1, field2) => {
        return field1.order - field2.order;
      }
    );
    const allFields = sortedNotificationFields.map((field) => {
      return (
        <Field
          key={field.id}
          field={field}
          allData={notificationData}
          updateField={notificationDispatcher}
          activeMergeFieldId={activeMergeFieldId}
          setActiveMergeFieldId={setActiveMergeFieldId}
          trigger={trigger}
        />
      );
    });

    return allFields;
  };

  // Initial useEffect hasn't run yet
  if (Object.keys(notificationData).length === 0) {
    return (
      <div className={classes.spinflex}>
        <div className={classes.spin}></div>
      </div>
    );
  }

  let trigger = "";
  notificationData.general.forEach((fieldData) => {
    if (fieldData.id === "trigger") {
      trigger = fieldData.value.value;
    }
  });

  /**
   * whether a template is selected
   */
  const isTemplateSelected = () => {
    let selectedTemplate = false;
    notificationData.general.forEach((field, index) => {
      if (field.id === "template" && !!field.value) {
        selectedTemplate = field.value;
      }
    });
    return selectedTemplate;
  };

  return (
    <div>
      {" "}
      {renderAllFields()}
      <textarea
        className={classes.textarea}
        value={JSON.stringify(notificationData)}
        name="wpmNotificationsData"
        readOnly
      />
      <Templates
        updateTemplate={notificationDispatcher}
        activeTemplateId={isTemplateSelected()}
        trigger={trigger}
      />
      {isTemplateSelected() ? (
        <Editor
          trigger={trigger}
          template={isTemplateSelected()}
          updateEditorData={updateEditorData}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default App;
